<template>
  <gmp-place-autocomplete
    v-if="placesReady"
    ref="autocompleteEl"
    placeholder="Start typing your address..."
    :class="{ 'gmp-input-error': error }"
  />
  <v-text-field
    v-else-if="placesFailed"
    :model-value="street"
    placeholder="Street address"
    aria-label="Address line 1"
    variant="outlined"
    density="comfortable"
    hide-details
    @update:model-value="onManualStreetInput"
  />
  <v-text-field
    v-else
    :model-value="place"
    placeholder="Start typing your address..."
    variant="outlined"
    density="comfortable"
    hide-details
    disabled
    style="opacity: 0.6"
  />
</template>

<script>
import { defineComponent } from 'vue';

// Address line 1: Google Places autocomplete when loaded, a plain street input when it failed,
// a disabled placeholder while loading. The parent wires the autocomplete via getAutocompleteEl().
export default defineComponent({
  name: 'StreetAddressField',

  props: {
    street: { type: String, default: '' },
    place: { type: String, default: '' },
    placesReady: { type: Boolean, default: false },
    placesFailed: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  },

  emits: ['update:street', 'update:place', 'manual-input'],

  methods: {
    getAutocompleteEl() {
      return this.$refs.autocompleteEl;
    },

    // Places unavailable: street is typed by hand; place drives the required check
    onManualStreetInput(value) {
      this.$emit('update:street', value);
      this.$emit('update:place', value || '');
      this.$emit('manual-input', value);
    }
  }
});
</script>
